import api from "@/services/api";

export type CronRunStatus = "running" | "success" | "failed";

export interface CronRun {
  id: number;
  jobName: string;
  status: CronRunStatus;
  trigger: string;
  startedAt: string;
  finishedAt: string | null;
  durationMs: number | null;
  summary: Record<string, unknown> | null;
  error: string | null;
}

export interface CronJob {
  name: string;
  description: string;
  cronExpr: string;
  timezone: string;
  nextRunAt: string;
  lastRun: CronRun | null;
}

export interface ListRunsParams {
  jobName?: string;
  status?: string;
  limit?: number;
  offset?: number;
}

export interface ListRunsResult {
  runs: CronRun[];
  total: number;
}

export async function getCronJobs(): Promise<CronJob[]> {
  const { data } = await api.get<CronJob[]>("/cron/jobs");
  return data;
}

export async function getCronRuns(params: ListRunsParams = {}): Promise<ListRunsResult> {
  const searchParams = new URLSearchParams();
  if (params.jobName) searchParams.set("jobName", params.jobName);
  if (params.status) searchParams.set("status", params.status);
  if (params.limit != null) searchParams.set("limit", String(params.limit));
  if (params.offset != null) searchParams.set("offset", String(params.offset));
  const qs = searchParams.toString();
  const { data } = await api.get<ListRunsResult>(`/cron/runs${qs ? `?${qs}` : ""}`);
  return data;
}
